import { __assign } from "tslib";
import { PluginKey } from 'prosemirror-state';
import { changeStylesString } from '../../utils';
export var reAnyValue = /^.+$/;
export var parseStyle = function (styleText) {
    var styles = (styleText || '').split(/\s*;\s*/).filter(Boolean).map(function (s) {
        var _a;
        var nameValue = s.split(/\s*:\s*/);
        return _a = {}, _a[nameValue[0]] = nameValue[1], _a;
    }).reduce(function (acc, val) { return (__assign(__assign({}, acc), val)); }, {});
    return styles;
};
export function setNodeStyle(nodeAttrs, styleType, value) {
    var attrs;
    if (new RegExp('[^-]?' + styleType + ':').test(nodeAttrs.style || '')) {
        var style = changeStylesString(nodeAttrs.style || '', { style: styleType, value: reAnyValue, newValue: value }).style;
        attrs = __assign(__assign({}, nodeAttrs), { style: style });
    }
    else if (nodeAttrs.style) {
        attrs = __assign(__assign({}, nodeAttrs), { style: nodeAttrs.style.replace(/;$/, '') + '; ' + styleType + ': ' + value + ';' });
    }
    else {
        attrs = __assign(__assign({}, nodeAttrs), { style: styleType + ': ' + value + ';' });
    }
    return attrs;
}
export var tableResizeKey = new PluginKey('table-resize');
export var tableColumnResizeKey = new PluginKey('table-column-resizing');
export var tableRowResizeKey = new PluginKey('table-row-resizing');
export function otherResizing(current, state) {
    var activeResize = false;
    activeResize = activeResize ||
        (current !== tableResizeKey && Boolean(tableResizeKey.get(state)) && tableResizeKey.getState(state).dragging);
    activeResize = activeResize ||
        (current !== tableColumnResizeKey && Boolean(tableColumnResizeKey.get(state)) && tableColumnResizeKey.getState(state).dragging);
    activeResize = activeResize ||
        (current !== tableRowResizeKey && Boolean(tableRowResizeKey.get(state)) && tableRowResizeKey.getState(state).dragging);
    return activeResize;
}
export function otherResizeHandle(current, state) {
    var activeResize = false;
    activeResize = activeResize ||
        (current !== tableColumnResizeKey &&
            Boolean(tableColumnResizeKey.get(state)) &&
            tableColumnResizeKey.getState(state).activeHandle > -1);
    activeResize = activeResize ||
        (current !== tableRowResizeKey && Boolean(tableRowResizeKey.get(state)) && tableRowResizeKey.getState(state).activeHandle > -1);
    return activeResize;
}
export function getTable(dom) {
    if (dom && dom.firstChild && dom.firstChild.nodeName === 'TABLE') {
        return dom.firstChild;
    }
    return dom;
}
export function domCellAround(target) {
    while (target && target.nodeName !== 'TD' && target.nodeName !== 'TH') {
        target = target.classList.contains('ProseMirror') ? null : target.parentNode;
    }
    return target;
}
export function cellIndexes(cell) {
    var row = cell.parentNode;
    return {
        cellIndex: cell.cellIndex,
        rowIndex: row.rowIndex
    };
}
export function parentNode(pos, predicate) {
    for (var depth = pos.depth; depth > 0; depth--) {
        var node = pos.node(depth);
        if (predicate(node)) {
            return { node: node, depth: depth };
        }
    }
    return null;
}
